"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiClient = exports.axiosInstance = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = require("../config");
const http_interceptors_1 = __importDefault(require("./http.interceptors"));
exports.axiosInstance = axios_1.default.create({
    baseURL: config_1.envConfig.apiURL,
    headers: {
        'x-business-unit': config_1.envConfig.currentBrand,
        'x-origin': 'catalogo',
    },
});
exports.axiosInstance.interceptors.request.use(http_interceptors_1.default, (error) => Promise.reject(error));
exports.apiClient = exports.axiosInstance;
